
import { Options, Vue } from 'vue-class-component'
import Research from '@/Research'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import Farm from '@/farm/Farm'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    research: Research,
    farm: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    targetTooltip() {
      if (this.research.effectType.target === 'farm') {
        return 'When researched, this will produce an upgrade for the farm.'
      } else if (this.research.effectType.target === 'employee') {
        return 'When researched, this will produce an item or effect for your employees.'
      }
      return ''
    },
    permanenceTooltip() {
      if (this.research.effectType.permanence === 'permanent') {
        return 'If use of the research is halted, effects already incurred are permanent.'
      } else if (this.research.effectType.permanence === 'temporary') {
        return 'If use of the research is halted, all effects will dissipate over time.'
      }
      return ''
    },
    durationTooltip() {
      if (this.research.effectType.timeType === 'instant') {
        return 'When used, all effects of this research will be applied instantly.'
      } else if (this.research.effectType.timeType === 'slow') {
        return 'When used, effects of this research will take some time before reaching full intensity.'
      }
      return ''
    }
  },
  computed: {
    lab() {
      return this.farm.state.lab
    }
  }
})
export default class ResearchCard extends Vue {
  isLoaded = false
  research!: Research
  farm!: Farm
}
